import { render, staticRenderFns } from "./setNewPassWord.vue?vue&type=template&id=d9b97680&scoped=true"
import script from "./setNewPassWord.vue?vue&type=script&lang=js"
export * from "./setNewPassWord.vue?vue&type=script&lang=js"
import style0 from "./setNewPassWord.vue?vue&type=style&index=0&id=d9b97680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b97680",
  null
  
)

export default component.exports